import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FeeAdjustPdfService {

  readonly baseURL = sessionStorage.getItem('NbaseURLs');
  baseURL_2 = 'https://localhost:44386/api';

  constructor(private httpClient: HttpClient) { }
  //sessionStorage.setItem('Paymode', 'T');
  //      sessionStorage.setItem('Paymodestr', 'RGTS/IMPS/NEFT');
  GetViewShowFeeAdjustDetail(YearCode: number,ShiftId: number) {
    debugger;
    return this.httpClient.get(this.baseURL + '/GetViewShowFeeAdjustDetail?YearCode=' + YearCode + '&&ShiftId=' + ShiftId);
  }

  DeleteFeeAdjustedCreated(TId: string, Yearcode: number, Admno: string)
  {
    debugger;
    return this.httpClient.delete(this.baseURL + '/DeleteFeeAdjustedCreated?TId=' + TId + '&&YearCode=' + Yearcode + '&&Admno=' + Admno);
  }

}
